var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-layout"},[_c('Header'),_vm._t("default"),_c('Footer'),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copy text-white"},[_c('div',{staticClass:"container py-2 roboto"},[_c('p',[_vm._v("Copyright © BIB Co., Ltd. All rights reserved.")])])])
}]

export { render, staticRenderFns }